export default {
      id: "icon-phone-usage",
      viewBox: "0 0 100 100",
      url: __webpack_public_path__ + "./icon/icons.svg#icon-phone",
      toString: function () {
        return this.url;
      }
    }